import React, { useEffect, useState } from "react";
import { Modal, BlockStack, Spinner, Text } from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import CommentsList from "./CommentsList";
import CommentComposer from "./CommentComposer";

export default function TaskChatModal({ open, task, onClose }) {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchComments = async () => {
    if (!task?.id) return;

    setLoading(true);
    try {
      const res = await axios.get(`/task-manager/${task.id}/comments`);
      setComments(res.data.data || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open) return;
    fetchComments();
  }, [open, task?.id]);

  return (
    <Modal open={open} onClose={onClose} title={``} large>
      <Modal.Section>
        {loading ? (
          <Spinner />
        ) : (
          <div className="mt-5">
            <BlockStack gap="400">
              <CommentComposer taskId={task.id} onSent={fetchComments} />
              <CommentsList
                comments={comments}
                onSent={fetchComments}
                onDelete={(id) =>
                  setComments((prev) => prev.filter((c) => c.id !== id))
                }
                onUpdate={(updated) =>
                  setComments((prev) =>
                    prev.map((c) => (c.id === updated.id ? updated : c))
                  )
                }
                taskId={task.id}
              />
            </BlockStack>
          </div>
        )}
      </Modal.Section>
    </Modal>
  );
}
